module.exports = __webpack_public_path__ + "static/media/package-8.24a108ec.jpg";